import React, { useState, useEffect, useMemo, useRef } from "react";
import { hasUnpaidCancelFee } from "utils/cancelPolicy";
import { useNavigate } from "react-router-dom";
import {
  Button, Card, CardBody, CardTitle, Col, Container, Input, Label, Row, Spinner, Alert, Modal, ModalHeader, ModalBody
} from "reactstrap";

import "flatpickr/dist/themes/material_blue.css";
import FlatPickr from "react-flatpickr";
import Breadcrumbs from "../../components/Common/Breadcrumb";

// Web için Google Autocomplete kütüphanesi
import Autocomplete from "react-google-autocomplete";

// --- MESAFE HESAPLAMA (HAVERSINE FORMÜLÜ) ---
function getDistanceFromLatLonInKm(lat1, lon1, lat2, lon2) {
  const R = 6371;
  const dLat = (lat2 - lat1) * (Math.PI / 180);
  const dLon = (lon2 - lon1) * (Math.PI / 180);
  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(lat1 * (Math.PI / 180)) * Math.cos(lat2 * (Math.PI / 180)) *
    Math.sin(dLon / 2) * Math.sin(dLon / 2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  return R * c; 
}

const YeniGorevOlustur = () => {
  document.title = "Yeni Görev Oluştur | Lojgo";
  const navigate = useNavigate();

  const GOOGLE_API_KEY = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;

const authUser = JSON.parse(localStorage.getItem("authUser") || "{}");
const loggedInUserId = authUser?.ID; 
const userType = Number(authUser?.Users_Type_ID);
const isAdmin = userType === 3; // ADMİN KONTROLÜ EKLENDİ
const isCustomer = userType === 1;

  const BASE_URL = "https://hiflowapi.stechomeyazilim.info";

  // --- STATE'LER ---
  const [loading, setLoading] = useState(false);
  const [publishing, setPublishing] = useState(false);
  const [alertConfig, setAlertConfig] = useState({ visible: false, message: "", type: "success" });

  // Kullanıcı Seçimi
  const [users, setUsers] = useState([]);
  const [selectedTaskUser, setSelectedTaskUser] = useState(loggedInUserId || "");
  const [userSearch, setUserSearch] = useState("");
  const [userDropdownOpen, setUserDropdownOpen] = useState(false);

  // Rota ve Koordinatlar
  const [startAddress, setStartAddress] = useState("");
  const [startLat, setStartLat] = useState(0);
  const [startLng, setStartLng] = useState(0);

  const [endAddress, setEndAddress] = useState("");
  const [endLat, setEndLat] = useState(0);
  const [endLng, setEndLng] = useState(0);
  
  const [km, setKm] = useState("");
  const [advertNote, setAdvertNote] = useState("");
  
  // Ayarlar ve Görev Tipi
  const [settings, setSettings] = useState(null);
  const [advertTypes, setAdvertTypes] = useState([]);
  const [advertTypeId, setAdvertTypeId] = useState(null);
  const [basePrice, setBasePrice] = useState("0");

  // Zaman
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [timeStart, setTimeStart] = useState("");
  const [timeEnd, setTimeEnd] = useState("");

  // Araç
  const [cars, setCars] = useState([]);
  const [selectedCarId, setSelectedCarId] = useState("new"); // Varsayılan "new" (yeni araç)
  const [carForm, setCarForm] = useState({
    carPlate: "", carBrand: "", carModel: "", carBodyType: "", engineType: "", chassisInformation: ""
  });

  // Ekstralar
  const [pricingOptions, setPricingOptions] = useState([]);
  const [selectedExtras, setSelectedExtras] = useState({});

  // Paycell
  const [paytrModal, setPaytrModal] = useState(false);
  const [paytrLoading, setPaytrLoading] = useState(false);
  const paycellWinRef = useRef(null);        // açılan Paycell popup penceresi
  const paycellPollRef = useRef(null);       // durum sorgu + pencere kontrol interval'i
  const paycellResolvedRef = useRef(false);  // sonuç bir kez işlensin (postMessage VEYA poll)
  const paycellRefNo = useRef(null);         // aktif referenceNumber (polling için)

  const closePaycellWindow = () => {
    try { paycellWinRef.current?.close(); } catch { /* ignore */ }
    paycellWinRef.current = null;
    if (paycellPollRef.current) { clearInterval(paycellPollRef.current); paycellPollRef.current = null; }
  };

  const pollPaycellStatus = async () => {
    const refNo = paycellRefNo.current;
    if (!refNo) return null;
    try {
      const sres = await fetch(`${BASE_URL}/api/Paycell/Status?ref=${encodeURIComponent(refNo)}`);
      const sdata = await sres.json();
      return sdata?.status || "pending";
    } catch { return null; }
  };
  const [pendingAdvertData, setPendingAdvertData] = useState(null);
  const [quickOfferPriceOverride, setQuickOfferPriceOverride] = useState("");

  // --- YARDIMCI FONKSİYONLAR ---
  const showAlert = (message, type = "success") => {
    setAlertConfig({ visible: true, message, type });
    setTimeout(() => setAlertConfig({ visible: false, message: "", type: "success" }), 5000);
    window.scrollTo({ top: 0, behavior: 'smooth' }); 
  };

async function getRouteDistanceKm(originLat, originLng, destLat, destLng) {
  return new Promise((resolve, reject) => {
    const service = new window.google.maps.DirectionsService();
    service.route(
      {
        origin: new window.google.maps.LatLng(originLat, originLng),
        destination: new window.google.maps.LatLng(destLat, destLng),
        travelMode: window.google.maps.TravelMode.DRIVING,
      },
      (result, status) => {
        if (status === "OK" && result.routes.length > 0) {
          const meters = result.routes[0].legs[0].distance.value;
          resolve(meters / 1000);
        } else {
          reject("Mesafe hesaplanamadı");
        }
      }
    );
  });
}

useEffect(() => {
  const calculateRoute = async () => {
    if (startLat && startLng && endLat && endLng) {
      setLoading(true); // Mesafe hesaplanırken yükleniyor gösterilsin
      const dist = await getRouteDistanceKm(startLat, startLng, endLat, endLng, GOOGLE_API_KEY);
      if (dist) {
        setKm(dist.toFixed(2));
      }
      setLoading(false);
    }
  };
  calculateRoute();
}, [startLat, startLng, endLat, endLng]);

  const normalizePlate = (p) => (p || "").toUpperCase().replace(/\s+/g, "").replace(/-/g, "").trim();

  // --- 1. BAŞLANGIÇ VERİLERİNİ YÜKLEME (Araçlar Hariç) ---
  useEffect(() => {
    const loadInitialData = async () => {
      setLoading(true);
      try {
        // Kullanıcıları Roller ile birlikte çekiyoruz
       // Kullanıcıları Roller ile birlikte çekiyoruz (SADECE ADMİN İSE)
if (isAdmin) {
  const usersRes = await fetch(`${BASE_URL}/Users?$expand=Users_Type`);
  const usersData = await usersRes.json();
  setUsers(usersData.value || []);
}

        const typeRes = await fetch(`${BASE_URL}/Advert_Type`);
        const typeData = await typeRes.json();
        const types = typeData.value || typeData;
        setAdvertTypes(types);
        if (types.length > 0) setAdvertTypeId(types[0].ID);

        const pricingRes = await fetch(`${BASE_URL}/Advert_Pricing`);
        const pricingData = await pricingRes.json();
        setPricingOptions(pricingData.value || pricingData.data || pricingData || []);

        const settingsRes = await fetch(`${BASE_URL}/Settings?$top=1`);
        const settingsData = await settingsRes.json();
        setSettings(settingsData.value?.[0] || null);

      } catch (error) {
        console.error("Veri yükleme hatası:", error);
        showAlert("Başlangıç verileri yüklenirken hata oluştu.", "danger");
      } finally {
        setLoading(false);
      }
    };

    loadInitialData();
  }, []);

  // --- 2. SEÇİLEN KULLANICIYA GÖRE ARAÇLARI YÜKLEME ---
 useEffect(() => {
    const fetchUserCars = async () => {
        if (!selectedTaskUser) {
            setCars([]);
            return;
        }
        try {
            // Sunucu tarafında filtreleme isteği
          const carRes = await fetch(`${BASE_URL}/Users_Car?$filter=Users_ID eq ${selectedTaskUser} and IsActive eq true&$orderby=ID desc`);
           const carData = await carRes.json();

// Sadece o an seçili olan kullanıcıya ait araçları süzüyoruz
const userOnlyCars = (carData.value || []).filter(c => c.Users_ID.toString() === selectedTaskUser.toString());
setCars(userOnlyCars);
            
            // Seçimi sıfırla
            setSelectedCarId("new"); 
            setCarForm({ carPlate: "", carBrand: "", carModel: "", carBodyType: "", engineType: "", chassisInformation: "" });
        } catch (error) {
            console.error("Araçlar yüklenirken hata:", error);
        }
    };
    fetchUserCars();
  }, [selectedTaskUser]);



  // Görev Tipi değiştiğinde Base Price güncelle
  useEffect(() => {
    if (!settings || !advertTypeId) return;
    
    const selectedType = advertTypes.find(t => t.ID === advertTypeId);
    const typeTitle = (selectedType?.Advert_Type_Title || "").toLowerCase();
    const isDriver = typeTitle.includes("sürücü") || typeTitle.includes("surucu");
    
    const price = isDriver ? settings.Km_Price_Car : settings.Km_Price_;
    setBasePrice(price?.toString() || "0");
  }, [settings, advertTypeId, advertTypes]);

  // Kayıtlı araç seçildiğinde formu doldur
  const handleCarSelect = (e) => {
    const val = e.target.value;
    setSelectedCarId(val);
    if (val !== "new" && val !== "") {
      const c = cars.find(x => x.ID.toString() === val);
      if (c) {
        setCarForm({
          carPlate: c.Users_Car_Plate || "",
          carBrand: c.Users_Car_Brand || "",
          carModel: c.Users_Car_Model || "",
          carBodyType: c.Car_Body_Type || "",
          engineType: c.Engine_Type || "",
          chassisInformation: c.ChassisInformation || ""
        });
      }
    } else {
      setCarForm({ carPlate: "", carBrand: "", carModel: "", carBodyType: "", engineType: "", chassisInformation: "" });
    }
  };

  // --- FİYAT HESAPLAMALARI ---
  const totalPrice = useMemo(() => {
    const distance = parseFloat(km) || 0;
    const pricePerKm = parseFloat(basePrice) || 0;
    const subTotal = distance * pricePerKm;

 const extraTotal = pricingOptions
  .filter(item => !item.Is_Cancel_Policy) // İptal cezası satırları hesaplamaya dahil edilmez
  .reduce((sum, item) => {
    const isSelected = !!selectedExtras[item.ID];
    const itemPrice = parseFloat(item.Price) || 0;
    return sum + (isSelected ? itemPrice : 0);
  }, 0);
  

    return subTotal + extraTotal;
  }, [km, basePrice, selectedExtras, pricingOptions]);

  // Hızlı teklif fiyatı — sistemdeki yüzdeye göre otomatik hesaplanır
  const computedQuickOfferPrice = useMemo(() => {
    if (!settings?.Quick_Offer_Percentage || !totalPrice) return "";
    const pct = parseFloat(settings.Quick_Offer_Percentage);
    if (isNaN(pct) || pct <= 0) return "";
    return (totalPrice * (pct / 100)).toFixed(2);
  }, [settings, totalPrice]);

  // Admin manuel değiştirebilir; müşteri için otomatik değer sabitlenir
  const effectiveQuickOfferPrice = useMemo(() => {
    const override = parseFloat(quickOfferPriceOverride);
    return !isNaN(override) && quickOfferPriceOverride !== "" ? override.toFixed(2) : computedQuickOfferPrice;
  }, [quickOfferPriceOverride, computedQuickOfferPrice]);


  // Sayfa kapanırsa popup'ı da kapat
  useEffect(() => () => closePaycellWindow(), []);

  const createAdvertFromData = async (data) => {
    // İlan Oluştur
    const advertRes = await fetch(`${BASE_URL}/Advert`, {
      method: "POST", headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        Created_DateTime: new Date().toISOString(),
        Advert_DateTime: data.startDT,
        Advert_DateTime2: data.endDT,
        Advert_DateTime3: data.endDT,
        Is_Active: true,
        Users_ID: parseInt(data.userId),
        Price: parseFloat(data.totalPrice.toFixed(2)),
        Quick_Offer_Price: parseFloat(data.quickOfferPrice) > 0 ? parseFloat(data.quickOfferPrice) : null,
        Advert_Type_ID: data.advertTypeId,
        Car_ID: data.carId,
        Estimated_Duration: data.estimatedDuration,
        Is_AdminCheck: false,
        Advert_Note: data.advertNote,
      })
    });
    const advertJson = await advertRes.json();
    const createdAdvertId = advertJson?.value?.[0]?.ID || advertJson?.ID;
    if (!createdAdvertId) throw new Error("İlan oluşturulamadı (Sunucudan ID dönmedi).");

    // Rota Kaydet
    await fetch(`${BASE_URL}/Advert_Location`, {
      method: "POST", headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        Advert_ID: createdAdvertId,
        Km: parseFloat(data.km),
        Advert_Location_StartAddress: data.startAddress,
        Advert_Location_FinishAddress: data.endAddress,
        Advert_Location_Lat_Start: parseFloat(data.startLat),
        Advert_Location_Long_Start: parseFloat(data.startLng),
        Advert_Location_Lat_Finish: parseFloat(data.endLat),
        Advert_Location_Long_Finish: parseFloat(data.endLng),
      })
    });

    // Fiyat Kaydet
    await fetch(`${BASE_URL}/Advert_Pricing`, {
      method: "POST", headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        Advert_ID: createdAdvertId,
        Advert_Pricing_Title: "Görev Ücretlendirmesi",
        Advert_Pricing_Desc: `${data.km} KM x ${data.basePrice} TL birim fiyat`,
        Price: parseFloat(((parseFloat(data.km) || 0) * parseFloat(data.basePrice)).toFixed(2)),
      })
    });

    // Ek Hizmetler
    for (let pId of (data.selectedPricingIds || [])) {
      await fetch(`${BASE_URL}/Users_Advert_Pricing`, {
        method: "POST", headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ Advert_ID: createdAdvertId, Advert_Pricing_ID: pId, Users_ID: parseInt(data.userId) })
      });
    }
    return createdAdvertId;
  };

  // Başarı: ilanı oluştur (postMessage VEYA polling tetikleyebilir; yalnız bir kez çalışır)
  const resolvePaycellSuccess = async (advertData) => {
    if (paycellResolvedRef.current) return;
    paycellResolvedRef.current = true;
    closePaycellWindow();
    setPaytrModal(false);
    setPublishing(true);
    try {
      await createAdvertFromData(advertData);
      setPendingAdvertData(null);
      showAlert("Ödeme başarılı! İlan başarıyla yayınlandı.", "success");
      setTimeout(() => navigate("/job-apply"), 2000);
    } catch (err) {
      showAlert("Ödeme alındı fakat ilan oluşturulurken hata oluştu: " + err.message, "danger");
    } finally {
      setPublishing(false);
    }
  };

  const resolvePaycellFail = (msg) => {
    if (paycellResolvedRef.current) return;
    paycellResolvedRef.current = true;
    closePaycellWindow();
    setPaytrModal(false);
    setPublishing(false);
    showAlert(msg || "Ödeme başarısız veya iptal edildi. Lütfen tekrar deneyin.", "danger");
  };

  // Paycell popup'tan gelen postMessage'leri dinle (polling ile aynı resolver'a düşer)
  useEffect(() => {
    const onMsg = (event) => {
      const d = event.data;
      if (!d || d.source !== "paycell") return;
      if (!paytrModal || !pendingAdvertData) return;
      if (d.status === "success") resolvePaycellSuccess(pendingAdvertData);
      else if (d.status === "fail") resolvePaycellFail();
    };
    window.addEventListener("message", onMsg);
    return () => window.removeEventListener("message", onMsg);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [paytrModal, pendingAdvertData]);

 const handleDeleteCar = async () => {
    if (!window.confirm("Bu aracı kalıcı olarak silmek istediğinize emin misiniz?")) return;
    try {
        // DELETE yerine PATCH atarak IsActive'i false yapıyoruz
        const res = await fetch(`${BASE_URL}/Users_Car(${selectedCarId})`, { 
            method: "PATCH",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ IsActive: false }) 
        });
        
        if (res.ok) {
            showAlert("Araç başarıyla silindi.", "success");
            setCars(cars.filter(c => c.ID.toString() !== selectedCarId));
            setSelectedCarId("new");
            setCarForm({ carPlate: "", carBrand: "", carModel: "", carBodyType: "", engineType: "", chassisInformation: "" });
        }
    } catch (e) {
        showAlert("Araç silinirken bir hata oluştu.", "danger");
    }
};


  // Ortak araç kaydetme/güncelleme ve tarih hesaplama yardımcıları
  const prepareCarAndDates = async () => {
    const startDT = new Date(startDate);
    const [sh, sm] = timeStart.split(":");
    startDT.setHours(parseInt(sh), parseInt(sm), 0);

    const endDT = new Date(endDate);
    const [eh, em] = timeEnd.split(":");
    endDT.setHours(parseInt(eh), parseInt(em), 0);

    if (new Date(endDate).setHours(0,0,0,0) < new Date(startDate).setHours(0,0,0,0)) {
      throw new Error("Bitiş tarihi başlangıç tarihinden önce olamaz.");
    }
    if (startDT.getTime() === endDT.getTime()) {
      throw new Error("Başlangıç ve bitiş zamanı aynı olamaz.");
    }
    if (endDT < startDT) {
      throw new Error("Bitiş saati başlangıç saatinden önce olamaz.");
    }

    let finalCarId = selectedCarId === "new" || selectedCarId === "" ? null : parseInt(selectedCarId);
    if (selectedCarId === "new" || selectedCarId === "") {
      const carRes = await fetch(`${BASE_URL}/Users_Car`, {
        method: "POST", headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          Users_Car_Plate: carForm.carPlate, Users_Car_Brand: carForm.carBrand,
          Users_Car_Model: carForm.carModel, Car_Body_Type: carForm.carBodyType,
          Engine_Type: carForm.engineType, ChassisInformation: carForm.chassisInformation,
          Users_ID: parseInt(selectedTaskUser), IsActive: true,
        })
      });
      const carData = await carRes.json();
      finalCarId = carData?.value?.[0]?.ID || carData?.ID;
    } else {
      await fetch(`${BASE_URL}/Users_Car(${selectedCarId})`, {
        method: "PATCH", headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          Users_Car_Plate: carForm.carPlate, Users_Car_Brand: carForm.carBrand,
          Users_Car_Model: carForm.carModel, Car_Body_Type: carForm.carBodyType,
          Engine_Type: carForm.engineType, ChassisInformation: carForm.chassisInformation,
        })
      });
      finalCarId = parseInt(selectedCarId);
    }

    const diffMs = endDT.getTime() - startDT.getTime();
    const totalMin = Math.max(0, Math.round(diffMs / 60000));
    const hh = String(Math.floor(totalMin / 60)).padStart(2, "0");
    const mm = String(totalMin % 60).padStart(2, "0");
    const estimatedDuration = `${hh}:${mm}`;

    const selectedPricingIds = Object.entries(selectedExtras).filter(([_, v]) => v).map(([k]) => Number(k));

    return {
      carId: finalCarId,
      startDT: startDT.toISOString(),
      endDT: endDT.toISOString(),
      estimatedDuration,
      userId: selectedTaskUser,
      totalPrice,
      advertTypeId,
      km,
      basePrice,
      startAddress, endAddress, startLat, startLng, endLat, endLng,
      advertNote,
      selectedPricingIds,
      quickOfferPrice: effectiveQuickOfferPrice,
    };
  };

  // --- GÖNDERİM (PUBLISH) İŞLEMİ ---
  const handlePublish = async () => {
    if (!isAdmin) {
      try {
        const { hasDebt, totalDebt } = await hasUnpaidCancelFee(loggedInUserId);
        if (hasDebt) {
          showAlert(`⚠️ ${totalDebt} TL tutarında ödenmemiş iptal cezanız bulunmaktadır. Lütfen önce borcunuzu ödeyin.`, "danger");
          return;
        }
      } catch (e) {
        console.error("Borç kontrolü yapılamadı", e);
      }
    }

    if (!selectedTaskUser) { showAlert("Lütfen görev sahibi kullanıcıyı seçin.", "danger"); return; }
    if (!startAddress || !endAddress || !km || !carForm.carPlate || !advertTypeId) {
      showAlert("Lütfen rota ve araç bilgilerini eksiksiz doldurun.", "danger"); return;
    }
    if (!startDate || !endDate || !timeStart || !timeEnd) {
      showAlert("Lütfen başlangıç ve bitiş tarih/saatlerini eksiksiz girin.", "danger"); return;
    }

    // Müşteri ise popup'ı tıklama anında (await'lerden önce) aç ki tarayıcı engellemesin
    let popup = null;
    if (!isAdmin) {
      popup = window.open("about:blank", "paycellPay",
        "width=480,height=720,menubar=no,toolbar=no,location=no,status=no");
      if (!popup) {
        showAlert("Açılır pencere engellendi. Lütfen bu site için pop-up'lara izin verin.", "danger");
        return;
      }
      paycellWinRef.current = popup;
      paycellResolvedRef.current = false;
      paycellRefNo.current = null;
    }

    setPublishing(true);
    try {
      const data = await prepareCarAndDates();

      if (isAdmin) {
        // Admin: direk ilan oluştur, ödeme yok
        await createAdvertFromData(data);
        showAlert("İlan başarıyla yayınlandı!", "success");
        setTimeout(() => navigate("/job-apply"), 2000);
      } else {
        // Müşteri: önce Paycell ödemesi al
        setPaytrLoading(true);

        // Kullanıcı IP'sini al
        let userIp = "0.0.0.0";
        try {
          const ipRes = await fetch("https://api.ipify.org?format=json");
          const ipData = await ipRes.json();
          userIp = ipData.ip || "0.0.0.0";
        } catch { /* IP alınamazsa varsayılanla devam et */ }

        const tokenRes = await fetch(`${BASE_URL}/api/Paycell/CreateSession`, {
          method: "POST",
          headers: { "Content-Type": "application/json", "Accept": "application/json" },
          body: JSON.stringify({
            Users_ID: loggedInUserId,
            Price:    parseFloat(totalPrice.toFixed(2)),
            UserIp:   String(userIp),
          }),
        });

        const tokenText = await tokenRes.text();
        let tokenData = {};
        try { tokenData = tokenText ? JSON.parse(tokenText) : {}; } catch { tokenData = {}; }
        setPaytrLoading(false);

        if (!(tokenData.status === "success" && tokenData.paymentUrl)) {
          throw new Error(tokenData.message || tokenData.reason || "Ödeme başlatılamadı. Lütfen tekrar deneyin.");
        }

        // Popup'ı Paycell ödeme sayfasına yönlendir
        paycellRefNo.current = tokenData.referenceNumber || null;
        popup.location.replace(tokenData.paymentUrl);
        setPendingAdvertData(data);
        setPaytrModal(true);
        setPublishing(false);

        // Fallback: her 2 sn'de bir durum sorgula + pencere kapandı mı kontrol et
        paycellPollRef.current = setInterval(async () => {
          if (paycellResolvedRef.current) return;

          const status = await pollPaycellStatus();
          if (paycellResolvedRef.current) return;
          if (status === "success") { await resolvePaycellSuccess(data); return; }
          if (status === "fail") { resolvePaycellFail(); return; }

          // Pencere kullanıcı tarafından kapatıldıysa (ve sonuç gelmediyse) sıfırla
          if (paycellWinRef.current && paycellWinRef.current.closed && !paycellResolvedRef.current) {
            closePaycellWindow();
            setPaytrModal(false);
            setPublishing(false);
            showAlert("Ödeme penceresi kapatıldı. İşlem tamamlanmadıysa tekrar deneyin.", "danger");
          }
        }, 2000);
      }
    } catch (error) {
      closePaycellWindow();
      console.error("Yayınlama Hatası:", error);
      showAlert(error.message || "İşlem sırasında hata oluştu.", "danger");
      setPublishing(false);
      setPaytrLoading(false);
    }
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title="Görevler" breadcrumbItem="Yeni Görev Oluştur" />

          <Alert isOpen={alertConfig.visible} color={alertConfig.type} className="border-0 shadow-sm font-size-15">
            <i className={`mdi ${alertConfig.type === "success" ? "mdi-check-circle" : "mdi-alert-circle"} me-2`}></i>
            {alertConfig.message}
          </Alert>

          {loading ? (
             <div className="text-center py-5">
               <Spinner color="primary" />
             </div>
          ) : (
            <Row>
              <Col lg="8">
                
                {/* 0. KULLANICI SEÇİMİ */}
             {isAdmin && (
  <Card className="shadow-sm border border-info rounded-4 mb-4">
    <CardBody>
      <CardTitle className="mb-3 fw-bold text-info">
          <i className="mdi mdi-account-tie me-2"></i>Görev Sahibi (Müşteri/Sürücü)
      </CardTitle>
      <div style={{ position: "relative" }}>
        <div className="input-group">
          <span className="input-group-text bg-soft-info border-info">
            <i className="mdi mdi-magnify text-info"></i>
          </span>
          <Input
            type="text"
            className="bg-soft-info border-info fw-bold text-dark"
            placeholder="Kullanıcı adı veya rol ile arayın..."
            value={userSearch}
            onChange={(e) => {
              setUserSearch(e.target.value);
              setUserDropdownOpen(true);
            }}
            onFocus={() => setUserDropdownOpen(true)}
            onBlur={() => setTimeout(() => setUserDropdownOpen(false), 200)}
          />
          {selectedTaskUser && (
            <button
              className="btn btn-outline-secondary border-info"
              type="button"
              onClick={() => {
                setSelectedTaskUser("");
                setUserSearch("");
              }}
            >
              <i className="mdi mdi-close"></i>
            </button>
          )}
        </div>
        {selectedTaskUser && (() => {
          const u = users.find(x => x.ID.toString() === selectedTaskUser.toString());
          return u ? (
            <div className="mt-2 px-2 py-1 bg-soft-info border border-info rounded-3 d-flex align-items-center gap-2">
              <i className="mdi mdi-account-check text-info"></i>
              <span className="fw-bold text-dark">{u.Users_NameSurname || u.Users_Name}</span>
              <span className="text-muted font-size-12">({u.Users_Type?.Users_Type_Title || "Bilinmeyen Rol"})</span>
            </div>
          ) : null;
        })()}
        {userDropdownOpen && (
          <div
            style={{
              position: "absolute", top: "100%", left: 0, right: 0, zIndex: 1000,
              maxHeight: "220px", overflowY: "auto",
              background: "#fff", border: "1px solid #0dcaf0",
              borderRadius: "0.5rem", boxShadow: "0 4px 16px rgba(0,0,0,0.12)",
              marginTop: "4px"
            }}
          >
            {users
              .filter(u => {
                const name = (u.Users_NameSurname || u.Users_Name || "").toLowerCase();
                const role = (u.Users_Type?.Users_Type_Title || "").toLowerCase();
                const q = userSearch.toLowerCase();
                return name.includes(q) || role.includes(q);
              })
              .map(u => (
                <div
                  key={u.ID}
                  className={`px-3 py-2 d-flex align-items-center gap-2 ${selectedTaskUser.toString() === u.ID.toString() ? "bg-soft-info" : ""}`}
                  style={{ cursor: "pointer", borderBottom: "1px solid #f0f0f0" }}
                  onMouseDown={() => {
                    setSelectedTaskUser(u.ID);
                    setUserSearch("");
                    setUserDropdownOpen(false);
                  }}
                  onMouseEnter={e => e.currentTarget.style.background = "#e8f7fb"}
                  onMouseLeave={e => e.currentTarget.style.background = selectedTaskUser.toString() === u.ID.toString() ? "" : ""}
                >
                  <i className="mdi mdi-account text-info"></i>
                  <span className="fw-bold">{u.Users_NameSurname || u.Users_Name}</span>
                  <span className="text-muted font-size-12 ms-auto">({u.Users_Type?.Users_Type_Title || "Bilinmeyen Rol"})</span>
                </div>
              ))}
            {users.filter(u => {
              const name = (u.Users_NameSurname || u.Users_Name || "").toLowerCase();
              const role = (u.Users_Type?.Users_Type_Title || "").toLowerCase();
              const q = userSearch.toLowerCase();
              return name.includes(q) || role.includes(q);
            }).length === 0 && (
              <div className="px-3 py-2 text-muted text-center font-size-13">Kullanıcı bulunamadı</div>
            )}
          </div>
        )}
      </div>
    </CardBody>
  </Card>
)}

                {/* 1. GÖREV TİPİ */}
                <Card className="shadow-sm border rounded-4 mb-4">
                  <CardBody>
                    <CardTitle className="mb-4 fw-bold"><i className="mdi mdi-briefcase-outline text-primary me-2"></i>Görev Tipi</CardTitle>
                    <div className="d-flex flex-wrap gap-2">
                      {advertTypes.map((type) => (
                        <Button 
                          key={type.ID} 
                          color={advertTypeId === type.ID ? "primary" : "light"}
                          onClick={() => setAdvertTypeId(type.ID)}
                          className="px-4 py-2 fw-bold"
                        >
                          {type.Advert_Type_Title}
                        </Button>
                      ))}
                    </div>
                  </CardBody>
                </Card>

                {/* 2. ROTA PLANLAMASI (OTOMATİK MESAFE EKLENDİ) */}
                <Card className="shadow-sm border rounded-4 mb-4">
                  <CardBody>
                    <CardTitle className="mb-4 fw-bold"><i className="mdi mdi-map-marker-path text-primary me-2"></i>Rota Planlaması</CardTitle>
                    <Row>
                      <Col md="12" className="mb-3">
                        <Label>Başlangıç Adresi</Label>
                        <div className="input-group">
                            <span className="input-group-text bg-light text-success"><i className="mdi mdi-circle-slice-8"></i></span>
                            <Autocomplete
                              apiKey={GOOGLE_API_KEY}
                              className="form-control"
                              placeholder="Yükleme adresi arayın..."
                              defaultValue={startAddress}
                              onChange={(e) => setStartAddress(e.target.value)}
                              onPlaceSelected={(place) => {
                                setStartAddress(place.formatted_address);
                                if (place.geometry?.location) {
                                  setStartLat(place.geometry.location.lat());
                                  setStartLng(place.geometry.location.lng());
                                }
                              }}
                              options={{ types: ["geocode", "establishment"], componentRestrictions: { country: "tr" } }}
                            />
                        </div>
                      </Col>
                      <Col md="12" className="mb-3">
                        <Label>Varış Adresi</Label>
                        <div className="input-group">
                            <span className="input-group-text bg-light text-danger"><i className="mdi mdi-map-marker"></i></span>
                            <Autocomplete
                              apiKey={GOOGLE_API_KEY}
                              className="form-control"
                              placeholder="Teslimat adresi arayın..."
                              defaultValue={endAddress}
                              onChange={(e) => setEndAddress(e.target.value)}
                              onPlaceSelected={(place) => {
                                setEndAddress(place.formatted_address);
                                if (place.geometry?.location) {
                                  setEndLat(place.geometry.location.lat());
                                  setEndLng(place.geometry.location.lng());
                                }
                              }}
                              options={{ types: ["geocode", "establishment"], componentRestrictions: { country: "tr" } }}
                            />
                        </div>
                      </Col>
                      <Col md="6">
                        <Label>Mesafe (KM)</Label>
                        <div className="input-group">
                            <Input type="number" placeholder="Otomatik hesaplanır..." value={km} disabled className="bg-light fw-bold text-primary" />
                            <span className="input-group-text bg-light fw-bold">KM</span>
                        </div>
                        <small className="text-muted mt-1 d-block">Mesafe başlangıç ve varış konumlarına göre otomatik hesaplanır.</small>
                      </Col>
                    </Row>
                  </CardBody>
                </Card>

                {/* 3. ZAMANLAMA */}
                <Card className="shadow-sm border rounded-4 mb-4">
                  <CardBody>
                    <CardTitle className="mb-4 fw-bold"><i className="mdi mdi-calendar-clock text-primary me-2"></i>Zaman Planlaması</CardTitle>
                    <Row>
                      <Col md="6" className="mb-3">
                        <Label>Başlangıç Tarihi</Label>
                        <FlatPickr
                          className="form-control bg-light border-light"
                          placeholder="Tarih seçin"
                          options={{ dateFormat: "Y-m-d", minDate: "today" }}
                          onChange={(date) => setStartDate(date[0])}
                        />
                      </Col>
                      <Col md="6" className="mb-3">
                        <Label>Başlangıç Saati</Label>
                        <Input type="time" className="bg-light border-light" value={timeStart} onChange={e => setTimeStart(e.target.value)} />
                      </Col>
                      <Col md="6" className="mb-3">
                        <Label>Bitiş Tarihi</Label>
                       <FlatPickr
  className="form-control bg-light border-light"
  placeholder="Tarih seçin"
  value={endDate}
  options={{ 
    dateFormat: "Y-m-d", 
    minDate: startDate || "today" // Başlangıç tarihinden öncesini seçtirmez
  }}
  onChange={(date) => {
    setEndDate(date[0]);
    // Eğer tarih değişirse saati sıfırlayabilir veya kontrol edebilirsiniz
  }}
/>
                      </Col>
                      <Col md="6">
                        <Label>Bitiş Saati</Label>
                      <Input 
  type="time" 
  className="bg-light border-light" 
  value={timeEnd} 
  onChange={e => {
    const newTimeEnd = e.target.value;
    // Eğer başlangıç ve bitiş günü aynıysa saat kontrolü yap
    if (startDate && endDate && startDate.getTime() === endDate.getTime()) {
      if (newTimeEnd <= timeStart) {
        showAlert("Aynı gün içinde bitiş saati başlangıç saatinden sonra olmalıdır.", "danger");
        return;
      }
    }
    setTimeEnd(newTimeEnd);
  }} 
/>
                      </Col>
                    </Row>
                  </CardBody>
                </Card>

                {/* 4. ARAÇ BİLGİLERİ */}
                <Card className="shadow-sm border rounded-4 mb-4">
                  <CardBody>
                   <div className="d-flex justify-content-between align-items-center mb-4">
    <CardTitle className="mb-0 fw-bold">
        <i className="mdi mdi-car text-primary me-2"></i>Araç Bilgileri
    </CardTitle>
    <div className="d-flex gap-2">
        <Input type="select" className="w-auto fw-bold text-primary bg-soft-primary border-primary" value={selectedCarId} onChange={handleCarSelect}>
            <option value="new">-- Kayıtlı Araç Seçin veya Yeni Yazın --</option>
            {cars.map(c => <option key={c.ID} value={c.ID}>{c.Users_Car_Plate} ({c.Users_Car_Brand})</option>)}
        </Input>
        {selectedCarId !== "new" && (
            <>
                <Button color="danger" outline size="sm" onClick={handleDeleteCar}>
                    <i className="mdi mdi-trash-can-outline"></i> Sil
                </Button>
                <Button color="secondary" outline size="sm" onClick={() => { setSelectedCarId("new"); setCarForm({ carPlate: "", carBrand: "", carModel: "", carBodyType: "", engineType: "", chassisInformation: "" }); }}>
                    <i className="mdi mdi-plus"></i> Yeni Form
                </Button>
            </>
        )}
    </div>
</div>

<Row>
  <Col md="12" className="mb-3">
    <Label>Plaka</Label>
    <Input type="text" placeholder="Örn: 34 ABC 123" className="fw-bold fs-5 text-uppercase bg-light border-light" value={carForm.carPlate} onChange={e => setCarForm({...carForm, carPlate: e.target.value})} />
  </Col>
  <Col md="6" className="mb-3">
    <Label>Marka</Label>
    <Input type="text" placeholder="Örn: BMW" className="bg-light border-light" value={carForm.carBrand} onChange={e => setCarForm({...carForm, carBrand: e.target.value})} />
  </Col>
  <Col md="6" className="mb-3">
    <Label>Model</Label>
    <Input type="text" placeholder="Örn: 3.20i" className="bg-light border-light" value={carForm.carModel} onChange={e => setCarForm({...carForm, carModel: e.target.value})} />
  </Col>
  <Col md="4" className="mb-3">
    <Label>Kasa Tipi</Label>
    <Input type="text" placeholder="SUV / Sedan" className="bg-light border-light" value={carForm.carBodyType} onChange={e => setCarForm({...carForm, carBodyType: e.target.value})} />
  </Col>
  <Col md="4" className="mb-3">
    <Label>Motor Tipi</Label>
    <Input type="text" placeholder="Elektrik vb." className="bg-light border-light" value={carForm.engineType} onChange={e => setCarForm({...carForm, engineType: e.target.value})} />
  </Col>
  <Col md="4">
    <Label>Şase No</Label>
    <Input type="text" placeholder="WBA123..." className="bg-light border-light" value={carForm.chassisInformation} onChange={e => setCarForm({...carForm, chassisInformation: e.target.value})} />
  </Col>
</Row>

                  </CardBody>
                </Card>


                {/* 5. MÜŞTERİ NOTU */}
                <Card className="shadow-sm border rounded-4 mb-4">
                  <CardBody>
                    <CardTitle className="mb-4 fw-bold">
                      <i className="mdi mdi-pencil-box-outline text-primary me-2"></i>Müşteri Notu (İsteğe Bağlı)
                    </CardTitle>
                    <Input 
                      type="textarea" 
                      rows="3" 
                      className="bg-light border-light" 
                      placeholder="Görevle veya araçla ilgili eklemek istediğiniz özel bir not ya da talep var mı?" 
                      value={advertNote} 
                      onChange={e => setAdvertNote(e.target.value)} 
                    />
                  </CardBody>
                </Card>
              </Col>

              {/* SAĞ TARAF - SİPARİŞ ÖZETİ VE EKSTRALAR */}
              <Col lg="4">
                
                <Card className="shadow-sm border rounded-4 mb-4">
                  <CardBody>
                    <CardTitle className="mb-4 fw-bold"><i className="mdi mdi-star-circle-outline text-warning me-2"></i>Ek Hizmetler</CardTitle>
                   {pricingOptions
  .filter(item => !item.Is_Cancel_Policy) // İptal cezası kayıtları listede görünmesin
  .map(item => (
                    <div 
                        key={item.ID} 
                        className={`p-3 mb-3 border rounded-3 d-flex align-items-center justify-content-between ${selectedExtras[item.ID] ? 'bg-soft-primary border-primary' : 'bg-light border-light'}`}
                        style={{ cursor: "pointer", transition: "all 0.2s" }}
                        onClick={() => {
                            setSelectedExtras(prev => ({
                                ...prev,
                                [item.ID]: !prev[item.ID] 
                            }));
                        }}
                    >
                        <div>
                            <h6 className="fw-bold mb-1">{item.Advert_Pricing_Title}</h6>
                            <p className="text-muted font-size-12 mb-1">{item.Advert_Pricing_Desc}</p>
                            <span className={`fw-bold font-size-13 ${selectedExtras[item.ID] ? 'text-primary' : 'text-secondary'}`}>
                                {item.Price === 0 ? "Ücretsiz" : `+${item.Price} TL`}
                            </span>
                        </div>
                        <div className="form-check form-switch form-switch-md mb-0">
                            <Input 
                                type="checkbox" 
                                className="form-check-input" 
                                style={{ cursor: "pointer", pointerEvents: "none" }} 
                                checked={selectedExtras[item.ID] || false} 
                                onChange={() => {}} 
                            />
                        </div>
                    </div>
                   ))}
                  </CardBody>
                </Card>

                <div style={{ position: "sticky", top: "85px" }}>
                    <Card className="shadow-sm border border-primary rounded-4">
                    <CardBody className="p-4">
                        <h5 className="fw-bold text-center mb-4 text-primary">Görev Özeti</h5>
                        
                        <div className="d-flex justify-content-between mb-3 border-bottom pb-2">
                            <span className="text-muted fw-bold">Baz Ücret ({basePrice} TL/Km)</span>
                            <span className="fw-bold text-dark">{((parseFloat(km)||0) * parseFloat(basePrice)).toFixed(2)} TL</span>
                        </div>

                        <div className="d-flex justify-content-between mb-3 border-bottom pb-2">
                            <span className="text-muted fw-bold">Ek Hizmetler</span>
                            <span className="fw-bold text-dark">
                                {pricingOptions.reduce((sum, item) => sum + (selectedExtras[item.ID] ? parseFloat(item.Price) : 0), 0).toFixed(2)} TL
                            </span>
                        </div>

                        {isAdmin && (
                        <div className="mb-3">
                            <Label className="text-muted fw-bold font-size-12">
                                <i className="mdi mdi-flash text-warning me-1"></i>Hızlı Teklif Fiyatı (TL)
                            </Label>
                            <Input
                                type="number"
                                className="fw-bold text-warning border-warning bg-soft-warning"
                                placeholder="Otomatik hesaplanır..."
                                value={quickOfferPriceOverride}
                                onChange={e => setQuickOfferPriceOverride(e.target.value)}
                            />
                            <small className="text-muted font-size-11">
                                Sistem yüzdesi: %{settings?.Quick_Offer_Percentage || "—"} → Otomatik: {computedQuickOfferPrice} TL
                                {quickOfferPriceOverride !== "" && (
                                    <span className="text-warning fw-bold"> (Manuel: {effectiveQuickOfferPrice} TL)</span>
                                )}
                            </small>
                        </div>
                        )}

                        <div className="text-center mb-4">
                            <span className="text-muted font-size-12 fw-bold d-block mb-1">TOPLAM TUTAR</span>
                            <h2 className="text-primary fw-900 mb-0">{totalPrice.toFixed(2)} TL</h2>
                        </div>

                        <Button color="primary" size="lg" className="w-100 fw-bold py-3 shadow d-flex justify-content-between align-items-center" onClick={handlePublish} disabled={publishing || paytrLoading}>
                            {(publishing || paytrLoading) ? (
                              <span className="d-flex align-items-center gap-2"><Spinner size="sm" color="light" /> {paytrLoading ? "Ödeme hazırlanıyor..." : "Lütfen bekleyin..."}</span>
                            ) : (
                              <span>{isAdmin ? "İlanı Yayınla" : "Öde ve Yayınla"}</span>
                            )}
                            <i className={`mdi ${isAdmin ? "mdi-cloud-upload-outline" : "mdi-credit-card-outline"} fs-4`}></i>
                        </Button>
                        {!isAdmin && (
                          <p className="text-muted text-center font-size-11 mt-2 mb-0">
                            <i className="mdi mdi-lock-outline me-1"></i>Güvenli ödeme Paycell 3D Secure altyapısı ile sağlanmaktadır.
                          </p>
                        )}
                    </CardBody>
                    </Card>
                </div>

              </Col>
            </Row>
          )}

        </Container>
      </div>
      {/* Paycell Ödeme Modal (popup durum paneli) */}
      <Modal isOpen={paytrModal} size="md" centered toggle={() => {
        closePaycellWindow();
        setPaytrModal(false);
        setPendingAdvertData(null);
        setPublishing(false);
        showAlert("Ödeme iptal edildi.", "danger");
      }}>
        <ModalHeader toggle={() => {
          closePaycellWindow();
          setPaytrModal(false);
          setPendingAdvertData(null);
          setPublishing(false);
          showAlert("Ödeme iptal edildi.", "danger");
        }}>
          <i className="mdi mdi-credit-card-outline me-2 text-primary"></i>
          Güvenli Ödeme — {totalPrice.toFixed(2)} TL
        </ModalHeader>
        <ModalBody>
          <div className="d-flex flex-column align-items-center justify-content-center text-center px-3 py-4">
            <i className="mdi mdi-open-in-new text-primary" style={{ fontSize: 48 }}></i>
            <h5 className="mt-3 fw-bold">Ödeme penceresi açıldı</h5>
            <p className="text-muted mb-3">
              Açılan pencerede kart bilgilerinizi girip 3D doğrulamayı tamamlayın.
              İşlem bitince bu pencere otomatik kapanır ve ilanınız yayınlanır.
            </p>
            <Button color="primary" outline onClick={() => {
              try { paycellWinRef.current?.focus(); } catch { /* ignore */ }
            }}>
              <i className="mdi mdi-cursor-default-click-outline me-1"></i>Ödeme Penceresine Dön
            </Button>
          </div>
        </ModalBody>
      </Modal>

    </React.Fragment>
  );
};

export default YeniGorevOlustur;